import React from 'react';
import NodeChart from './NodeChart';

const NestedTrendCharts = ({ nodes, metricMode, totalNonfarmValues, level = 0 }) => {
  // Sort the top-level nodes as well
  const sortedNodes = [...nodes].sort((a, b) => a.id.localeCompare(b.id));

  return (
    <div>
      {sortedNodes.map((node) => (
        <NodeChart
          key={node.id}
          node={node}
          level={level}
          metricMode={metricMode}
          totalNonfarmValues={totalNonfarmValues}
        />
      ))}
    </div>
  );
};

export default NestedTrendCharts;